<div class="layout">
    <div class="header-section">
        <img src="HomeBannerCastleOnly.png" fetchPriority="high" class="background-image">
        <div class="intro-container">
            <p class="intro-text-title">{{'terms-and-conditions.header' | translate}}</p>
        </div>
    </div>
    <div class="text-section">
        <h1>{{'terms-and-conditions.title' | translate}}</h1>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter1.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter1.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter1.text2' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter2.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter2.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter2.text2' | translate}}</p>
            <p>{{'terms-and-conditions.chapter2.text3' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter3.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter3.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter3.text2' | translate}}</p>
            <p>{{'terms-and-conditions.chapter3.text3' | translate}}</p>
            <p>{{'terms-and-conditions.chapter3.text4' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter4.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter4.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter4.text2' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter5.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter5.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter5.text2' | translate}}</p>
            <p>{{'terms-and-conditions.chapter5.text3' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter6.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter6.text' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter7.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter7.text' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter8.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter8.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter8.text2' | translate}}</p>
            <p>{{'terms-and-conditions.chapter8.text3' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter9.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter9.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter9.text2' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter10.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter10.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter10.text2' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter11.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter11.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter11.text2' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter12.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter12.text' | translate}}</p><br>
            <p>
                <span *ngFor="let line of ('terms-and-conditions.chapter12.breaks' | translate)">{{line}}<br></span>
            </p><br>
            <p>{{'terms-and-conditions.chapter12.text2' | translate}}</p>
            <h4>{{'terms-and-conditions.chapter12.title2' | translate}}</h4>
            <p>{{'terms-and-conditions.chapter12.text3' | translate}}</p>
            <h4>{{'terms-and-conditions.chapter12.title3' | translate}}</h4>
            <p>{{'terms-and-conditions.chapter12.text4' | translate}}</p>
            <h4>{{'terms-and-conditions.chapter12.title4' | translate}}</h4>
            <p>{{'terms-and-conditions.chapter12.text5' | translate}}</p><br>
            <p>
                <span *ngFor="let line of ('terms-and-conditions.chapter12.text5.breaks' | translate)">{{line}}<br></span>
            </p><br>
            <p>{{'terms-and-conditions.chapter12.text6' | translate}}</p>
            <p>{{'terms-and-conditions.chapter12.text7' | translate}}</p>
        </div>
        <div class="chapter">
            <h3>{{'terms-and-conditions.chapter13.title' | translate}}</h3>
            <p>{{'terms-and-conditions.chapter13.text' | translate}}</p>
            <p>{{'terms-and-conditions.chapter13.text2' | translate}}</p>
        </div>
    </div>
</div>
